import { filter } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { CommonState } from '../+state/common.reducer';
import {
  loadConfiguration,
  loadUser,
  loadUserEntitlements,
} from '../+state/common.actions';
import { getConfiguration } from '../+state/common.selectors';
import { AuthenticationService } from './auth/authentication.service';
import {createUid} from "@dcs-workspace/shared";

@Injectable({
  providedIn: 'root',
})
export class AppInitService {
  constructor(
    private store: Store<CommonState>,
    private authService: AuthenticationService
  ) {}

  async init(): Promise<unknown> {
    if (location.hash.length > 0) {
      const token = location.hash.replace('#id_token=', '');

      sessionStorage.setItem('id_token', token);

      history.replaceState(
        {},
        document.title,
        window.location.href.split('#')[0]
      );
    }

    return new Promise((resolve) => {
      this.store
        .select(getConfiguration)
        .pipe(filter((config) => !!config))
        .subscribe((config) => {
          this.authService.isAuthenticated(config.apiUrl).subscribe(() => {
            const token = sessionStorage.getItem('id_token');
            this.store.dispatch(loadUser({ token }));
            this.store.dispatch(loadUserEntitlements());
            resolve(true);
          });
        });
      this.store.dispatch(loadConfiguration());
      this.store.dispatch(createUid());
    });
  }
}
